(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-instructions-instruction"] && !Shopify.designMode) return;
  try {
    
// This JavaScript will only be included once, regardless of how many instances of this section exist on the page
if (!window.sectionInstructionsInitialized) {
  window.sectionInstructionsInitialized = true;
  
  $(document).ready(function() {
    // Hide all instruction containers initially
    $('.instruction-container').hide();
    
    // Use jQuery click handler with delegation
    $(document).on('click', '.accordion-header', function() {
      const clickedHeader = $(this);
      const contentContainer = clickedHeader.next('.instruction-container');
      const wasActive = clickedHeader.hasClass('active');
      
      // Close all accordions first
      $('.accordion-header.active').not(clickedHeader).each(function() {
        $(this).removeClass('active');
        $(this).find('.accordion-icon').css('transform', 'rotate(0deg)');
        $(this).next('.instruction-container').slideUp(300);
      });
      
      // Toggle the clicked accordion
      if (wasActive) {
        // If it was already active, close it
        clickedHeader.removeClass('active');
        clickedHeader.find('.accordion-icon').css('transform', 'rotate(0deg)');
        contentContainer.slideUp(300);
      } else {
        // If it was closed, open it
        clickedHeader.addClass('active');
        clickedHeader.find('.accordion-icon').css('transform', 'rotate(90deg)');
        contentContainer.slideDown(300);
      }
    });

    // Close all accordions when switching between instruction types
    $(document).on('click', '#hardware-instructions-select, #electrical-instructions-select, #lighting-instructions-select', function() {
      // Close all accordions
      $('.accordion-header.active').each(function() {
        $(this).removeClass('active');
        $(this).find('.accordion-icon').css('transform', 'rotate(0deg)');
        $(this).next('.instruction-container').slideUp(300);
      });
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-trade-tabs"]) return;
  try {
    
  $(document).ready(function () {
    $('.trade-carousel').hide().first().show().addClass('active');
    $('.switches-sockets-landing-link').click(function () {
      var $this = $(this);
      var $siblings = $this.parent().children();
      var position = $siblings.index($this);
      $('.trade-carousel').removeClass('active').hide().eq(position).fadeIn().addClass('active');
      $siblings.removeClass('active');
      $this.addClass('active');
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-carousel-with-header"]) return;
  try {
    
  $(document).ready(function() {
    $('.carousel').on('scroll', function() {
      $this = $(this);
      var scrollLeft = $this.scrollLeft();
      var scrollWidth = this.scrollWidth;
      var clientWidth = this.clientWidth;
      var scrollbarValue = (scrollLeft / (scrollWidth - clientWidth)) * 100;
      var scrollbar = $this.parent().parent().next('.scrollbar-container').find('.carousel-scrollbar');

      scrollbar.val(scrollbarValue);
    });

    $(document).on('input', '.carousel-scrollbar', function() {
      $this = $(this);
      var overflowContainer = $this.closest('.scrollbar-container').prev('.carousel-wrapper').find('.carousel');
      var scrollWidth = overflowContainer.prop('scrollWidth');
      var clientWidth = overflowContainer.width();
      var scrollLeft = ($this.val() / 100) * (scrollWidth - clientWidth);

      overflowContainer.scrollLeft(scrollLeft);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-cookie-type"]) return;
  try {
    
  $(document).ready(function(){

    $('.section-heading').on('click', function(){
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).siblings('.cookie-list').slideUp();
      } else {
        $(this).addClass('active');
        $(this).siblings('.cookie-list').slideDown();
      }
    })
  });

  } catch(e) { console.error(e); }
})();
})();
